// This file is the client-side equivalent of instrumentation.ts.
// Next.js 15.3+ / 16 loads this automatically on the browser before the app
// starts, even when using Turbopack (which skips Sentry's webpack plugin).
import * as Sentry from '@sentry/nextjs';
import './sentry.client.config';

// Required for navigation instrumentation
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
